














import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import FoglioFirme from "../FoglioFirme.vue";

@Component({
  components: {
    FoglioFirme
  }
})
export default class FoglioFirmeDialog extends Vue {
  @Prop() nomeSoggetto!: string;
  @Prop() idRichiesta!: number;
  @Prop() soggetto!: string;
  @Prop() activityType!:string;
  @Prop() info!: any;
  private foglioFirmeDialog: boolean;

  constructor() {
    super();
    this.foglioFirmeDialog = false;
  }

  close() {
    this.foglioFirmeDialog = false;
    bus.$emit("destroyFoglioFirmeDialog");
  }
}
